// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoActivityType\ApiCargoActivityType.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';

// CargoActivityTypeData is the class that CargoActivityType serializes to/from
export interface CargoActivityTypeData {
    Id : number;
    Url : string | null;
	
    Organization : OrganizationData | null;
    OrganizationId : number;
	
    Active : boolean;
    DisplayOrder : number;
    Name : string;
}

// CargoActivityTypeOptions is the class which may be passed to the CargoActivityType constructor to define optional initial data values
export interface CargoActivityTypeOptions {
    Id : number;
    Url? : string | null;
	
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
	
    Active? : boolean;
    DisplayOrder? : number;
    Name? : string;
}

export class CargoActivityType {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
	
    public Active : DataSignal<boolean>;
    public DisplayOrder : DataSignal<number>;
    public Name : DataSignal<string>;

    constructor();
    constructor(data : CargoActivityTypeOptions);
    constructor(data: CargoActivityTypeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
    }

    static key(obj : CargoActivityType) {
        return obj.Id();
    }
    
    static dataKey(obj : CargoActivityTypeOptions) {
        return obj.Id;
    }

    static update(obj : CargoActivityType, data : CargoActivityTypeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CargoActivityType.ts